export const content = {
  breadcrumbRoot: 'Roaming & International',
  breadcrumbCurrent: 'Countries',
  breadcrumbMobile: 'Select another country',
  heading: (country: string) => `Using SMARTY to call ${country}`,
  callsToMobiles: 'Calls to Mobiles',
  callsToLandlines: 'Calls to Landlines',
  callsToOther: 'Calls to Other',
  texts: 'Texts',
  pictureMms: 'Picture message (MMS)',
  videoMms: 'Video message (MMS)',
  other: 'Other',
  unitMin: '/ min',
  unitSms: '/ sms',
  unitMms: '/ mms',
  seeAllPricesText: 'See all prices',
  seeAllPricesAriaLabel:
    'See all prices .PDF (253KB) link opens in a new window',
  priceGuideLink: '/priceguide',
  cardHeading: 'Before you call or text',
  cardSubheading: 'Buy "Out of plan" add-ons',
  cardBody:
    'All international calls and texts are paid for with your "Out of plan" add-ons.',
  cardLinkText: 'Buy "Out of plan" add-ons',
  vatNote: 'Prices are shown including VAT where applicable.',
  pageTitle: (country: string) => `Using SMARTY to call ${country}`,
}
